<div class="!pl-16">
  <span>{{ 'patientSearch_header_name' | translate }}</span>
</div>
<div>
  <span>{{ 'patientSearch_header_birthDate' | translate }}</span>
</div>
<div>
  <span>{{ 'patientSearch_header_status' | translate }}</span>
</div>
<div>
  <span>{{ 'patientSearch_header_phoneNumber' | translate }}</span>
</div>
<div>
  <span>{{ 'patientSearch_header_email' | translate }}</span>
</div>
